export const applyIfNewer =
  <T extends { ts: number }>(incoming: T) =>
  (current: { ts: number }): T | undefined =>
    incoming.ts >= current.ts ? incoming : undefined;
